const isValidHex = (hex: string) => {
  return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(hex);
};

export const colorYiq = (colorHex: string) => {
  if (!isValidHex(colorHex)) {
    throw new Error(
      'The value "' + colorHex + '" is not a valid hex color string.',
    );
  }

  if (colorHex.length === 4) {
    colorHex = colorHex.replace(/^#(.)(.)(.)/i, "#$1$1$2$2$3$3");
  }

  var n = parseInt(colorHex.slice(1), 16);
  var r = (n & 0xff0000) >> 16;
  var g = (n & 0xff00) >> 8;
  var b = n & 0xff;
  var yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? "black" : "white";
};
